import { globalConfig } from './global-config'
import { localConfig } from './local-config'

export const loadConfig = isGlobal => {
  return isGlobal ? globalConfig : localConfig
}
